// Dependencies
import TweenMax from 'gsap';
import WebFont  from 'webfontloader';
import Emitter  from 'tiny-emitter';
import Manager  from 'manager';

// App
class App {
  /**
   * Constructor: Application Constructor.
   */
  constructor() {
    Promise.all([App.fontReady(), App.DOMReady()])
      .then(App.init);
  }


  /**
   * Font Ready: Load Fonts (Google Fonts, Typekit,...).
   */
  static fontReady() {
    return new Promise((resolve, reject) => {
      WebFont.load({
        google: {
          families: ['Open Sans', 'Montserrat']
        },
        active: resolve,
        inactive: reject,
      });
    });
  }


  /**
   * DOM Ready: Wait for DOM to be ready.
   */
  static DOMReady() {
    return new Promise((resolve, reject) => {
      document.addEventListener('DOMContentLoaded', resolve);
    });
  }


  /**
   * Initialisation: Prepare DOM and add class to HTML element.
   */
  static init() {
    // DOM Ready
    document.documentElement.classList.add('is-ready');

    // Emitter
    window.Emitter = new Emitter();

    // Manager
    window.Manager = new Manager();
  }
}

new App();


// WEBPACK FOOTER //
// ./src/js/main.js